import * as React from 'react'
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { TerminalScoreContext } from '../TerminalScoreProvider';
import TerminalStat from './TerminalStat';


type Props = {
  nodeId: string,
  className?: string
}

const MAXIMUM_DISABLE_RATIO = 0.25

const TerminalMaximumDisableRatio: React.FC<Props> = ({ nodeId, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);

  const graphNode = graph.getNode(nodeId);
  const terminalNode = terminalScore.getNode(nodeId);
  const interpreter = new TerminalNodeInterpreter(terminalNode);


  const incomingEdges = graph.getIncomingEdges(nodeId);
  const disabledIncomingEdges = incomingEdges.filter(e => !e.active)
  const disabledIncomingRatio = disabledIncomingEdges.length / incomingEdges.length;



  const isAboveMaximum = disabledIncomingRatio > MAXIMUM_DISABLE_RATIO;
  return (
    <TerminalStat label="Channel disable ratio" value={<p>{Math.round(disabledIncomingRatio * 100)}%</p>} isMatched={!isAboveMaximum} />
  );
}

export default TerminalMaximumDisableRatio;

